<script setup>
import chatIllustration from '~/assets/images/homepage/hero/usp-chat-illustration.jpg';
import eventsIllustration from '~/assets/images/homepage/hero/usp-events-illustration.jpg';
import userProfileIllustration from '~/assets/images/homepage/hero/usp-user-profile-illustration.jpg';
</script>

<template>
  <section class="social-usps-wrapper">
    <div class="social-usp-container">
      <div
        class="social-usp-card user-profile"
        :style="{ backgroundImage: `url(${userProfileIllustration})` }"
      />
      <span class="social-usp-copy"> {{ $t('t_HOMEPAGEUSPUSERPROFILETITLE') }} </span>
    </div>
    <div class="social-usp-container">
      <div
        class="social-usp-card chat"
        :style="{ backgroundImage: `url(${chatIllustration})` }"
      />
      <span class="social-usp-copy"> {{ $t('t_HOMEPAGEUSPCHATTITLE') }} </span>
    </div>
    <div class="social-usp-container">
      <div
        class="social-usp-card events"
        :style="{ backgroundImage: `url(${eventsIllustration})` }"
      />
      <span class="social-usp-copy"> {{ $t('t_HOMEPAGEUSPEVENTSTITLE') }} </span>
    </div>
  </section>
</template>

<style scoped lang="scss">
.social-usps-wrapper {
  display: flex;
  gap: $wds-spacing-m;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;

  @include no-scrollbar;

  .social-usp-container {
    display: flex;
    flex-direction: column;
    flex: 1 1 33%;
    min-width: wds-rem(208px);
    min-height: wds-rem(286px);
    border-radius: $wds-border-radius-xxl;
    overflow: hidden;
    scroll-snap-align: center;
    background-color: $wds-color-white;

    .social-usp-card {
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      height: wds-rem(184px);
    }

    .social-usp-copy {
      flex: 1;

      @include title-5-bld;

      padding: 0 $wds-spacing-m $wds-spacing-m;
      text-align: center;
    }
  }

  @include desktop {
    .social-usp-container .social-usp-copy {
      padding: 0 $wds-spacing-xxl $wds-spacing-m;
    }
  }
}
</style>
